import React from 'react';
import { AlertTriangle } from '@saleshandy/icons';

import Modal from '../../../shared/design-system/ui/modal';
import {
  getUserShAccountId,
  getUserTrackingId,
} from '../../../shared/utils/user-details';
import { AnalyticsEvents } from '../../../shared/enums/analytics';
import { AuthHelper, getToken } from '../../../shared/utils';
import { getDemoAccountEnteredTimestamp } from '../utils/helper';

interface GlobalRestrictionModalProps {
  show: boolean;
  onSubmit?: () => void;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  primaryBtnLabel?: string;
  primaryBtnLoading?: boolean;
  redirectTo?: string;
}

const GlobalRestrictionModal: React.FC<GlobalRestrictionModalProps> = ({
  show,
  onSubmit,
  onClose,
  title,
  content,
  primaryBtnLabel = 'Sign up',
  primaryBtnLoading = false,
  redirectTo = 'sequence',
}) => {
  const handleOnSubmit = () => {
    if (onSubmit) {
      onSubmit();
    } else {
      window.analytics?.track?.({
        userId: getUserTrackingId(),
        event: AnalyticsEvents.DemoEnded,
        properties: {
          shAccountId: getUserShAccountId(),
          reason: 'signup',
          duration_seconds: getDemoAccountEnteredTimestamp(),
        },
      });

      AuthHelper.logoutDemoAccount({ shouldRedirect: false });

      const token = getToken();
      if (token) {
        window.open(`${process.env.REACT_APP_BASE_URL}/${redirectTo}`);
        window.close();
      } else {
        window.open(
          `${process.env.REACT_APP_BASE_URL}/signup?utm_source=demoaccount`,
        );
        window.close();
      }
    }
  };

  return (
    <Modal
      show={show}
      className="global-restriction-modal"
      title={
        <div className="d-flex align-items-center gap-8">
          <AlertTriangle width={24} height={24} color="#D97706" />
          <span>{title}</span>
        </div>
      }
      onHide={onClose}
      primaryBtnLabel={primaryBtnLabel}
      secondaryBtnLabel="Cancel"
      primaryBtnClickedHandler={handleOnSubmit}
      secondaryBtnClickedHandler={onClose}
      primaryBtnDisabled={primaryBtnLoading}
      primaryBtnLoading={primaryBtnLoading}
    >
      <>{content}</>
    </Modal>
  );
};

export default GlobalRestrictionModal;
